var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHorizontal3NoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;}\n\t.st3{fill:#E53366;}\n\t.st4{fill:#00D681;}\n\t.st5{fill:#4D6ADD;}\n\t.st6{fill:#333333;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M718.3,409.7v327.5c0,21.8-17.7,39.5-39.5,39.5s-39.5-17.7-39.5-39.5V409.7c0-21.8,17.7-39.5,39.5-39.5 S718.3,387.9,718.3,409.7z M661.9,330.7c0-9.4,7.6-16.9,16.9-16.9c9.4,0,16.9,7.6,16.9,16.9v28.2h-5.6 C674.5,358.9,661.9,346.3,661.9,330.7z M684.5,409.7c0-3.1-2.5-5.6-5.6-5.6c-3.1,0-5.6,2.5-5.6,5.6v327.5c0,3.1,2.5,5.6,5.6,5.6 c3.1,0,5.6-2.5,5.6-5.6V409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M825.6,409.7v84.7h-33.9v-84.7c0-3.1-2.5-5.6-5.6-5.6c-3.1,0-5.6,2.5-5.6,5.6v327.5c0,3.1,2.5,5.6,5.6,5.6 c3.1,0,5.6-2.5,5.6-5.6v-192c0-3.1-2.5-5.6-5.6-5.6v-33.9c21.8,0,39.5,17.7,39.5,39.5v192c0,21.8-17.7,39.5-39.5,39.5 s-39.5-17.7-39.5-39.5V409.7c0-21.8,17.7-39.5,39.5-39.5S825.6,387.9,825.6,409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M932.9,370.2v367c0,21.8-17.7,39.5-39.5,39.5s-39.5-17.7-39.5-39.5v-367h33.9v367c0,3.1,2.5,5.6,5.6,5.6 c3.1,0,5.6-2.5,5.6-5.6v-367H932.9z M882.1,358.9h-5.6v-28.2c0-9.4,7.6-16.9,16.9-16.9c9.4,0,16.9,7.6,16.9,16.9 C910.3,346.3,897.7,358.9,882.1,358.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1040.2,409.7v367h-33.9v-367c0-3.1-2.5-5.6-5.6-5.6H995v372.7h-33.9V370.2h39.5 C1022.5,370.2,1040.2,387.9,1040.2,409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1209.6,409.7v327.5c0,21.8-17.7,39.5-39.5,39.5s-39.5-17.7-39.5-39.5V409.7c0-21.8,17.7-39.5,39.5-39.5 S1209.6,387.9,1209.6,409.7z M1175.7,409.7c0-3.1-2.5-5.6-5.6-5.6s-5.6,2.5-5.6,5.6v327.5c0,3.1,2.5,5.6,5.6,5.6s5.6-2.5,5.6-5.6 V409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1316.9,409.7v367H1283v-367c0-3.1-2.5-5.6-5.6-5.6h-5.6v372.7h-33.9V370.2h39.5 C1299.2,370.2,1316.9,387.9,1316.9,409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1345.1,776.7V370.2h33.9v406.6H1345.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1486.3,409.7v90.3c0,8.4-2.6,16.2-7.1,22.6c4.5,6.4,7.1,14.2,7.1,22.6v231.5h-33.9V545.2 c0-3.1-2.5-5.6-5.6-5.6h-5.6v237.2h-33.9V370.2h39.5C1468.6,370.2,1486.3,387.9,1486.3,409.7z M1452.4,409.7 c0-3.1-2.5-5.6-5.6-5.6h-5.6v101.6h5.6c3.1,0,5.6-2.5,5.6-5.6V409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1593.5,409.7v84.7h-33.9v-84.7c0-3.1-2.5-5.6-5.6-5.6s-5.6,2.5-5.6,5.6v96h45.2v33.9h-45.2v197.6 c0,3.1,2.5,5.6,5.6,5.6s5.6-2.5,5.6-5.6V550.9h33.9v186.3c0,21.8-17.7,39.5-39.5,39.5s-39.5-17.7-39.5-39.5V409.7 c0-21.8,17.7-39.5,39.5-39.5S1593.5,387.9,1593.5,409.7z M1537.1,330.7c0-9.4,7.6-16.9,16.9-16.9s16.9,7.6,16.9,16.9v28.2h-5.6 C1549.7,358.9,1537.1,346.3,1537.1,330.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M968,323c0-9.8,7.3-16.5,16.6-16.5c6.1,0,10,3,12.5,6.8l-4.1,2.2c-1.7-2.7-4.8-4.6-8.4-4.6 c-6.7,0-11.6,5.1-11.6,12.3c0,7.1,5,12.3,11.6,12.3c3.6,0,6.8-2,8.4-4.6l4.1,2.2c-2.5,3.7-6.4,6.8-12.5,6.8 C975.3,339.5,968,332.8,968,323z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1022.9,323c0-9.5,6.6-16.5,16.1-16.5c9.5,0,16.1,7,16.1,16.5s-6.6,16.5-16.1,16.5 C1029.5,339.5,1022.9,332.5,1022.9,323z M1050.2,323c0-7-4.4-12.3-11.2-12.3c-6.9,0-11.2,5.2-11.2,12.3c0,7,4.3,12.3,11.2,12.3 C1045.8,335.3,1050.2,330,1050.2,323z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1110.8,339v-25l-10.4,25h-2l-10.4-25v25h-4.8v-32h6.9l9.3,22.6l9.3-22.6h6.9v32H1110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1145.1,326.4V307h4.8v19.3c0,5.5,3,9,8.6,9c5.6,0,8.6-3.5,8.6-9V307h4.8v19.4c0,8-4.5,13.1-13.4,13.1 C1149.6,339.5,1145.1,334.3,1145.1,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1224,339l-17.7-24.2V339h-4.8v-32h4.9l17.4,23.6V307h4.8v32H1224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1258.1,339v-32h4.8v32H1258.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1292.4,339v-32h11.4c10,0,16.6,6.8,16.6,16c0,9.2-6.6,16-16.6,16H1292.4z M1315.5,323 c0-6.6-4.1-11.8-11.6-11.8h-6.6v23.5h6.6C1311.2,334.7,1315.5,329.5,1315.5,323z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1369.5,339l-2.6-6.6h-15.3l-2.6,6.6h-5.5l12.7-32h6l12.7,32H1369.5z M1359.2,311.9l-6.2,16.2h12.5 L1359.2,311.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1401.1,339v-32h11.4c10,0,16.6,6.8,16.6,16c0,9.2-6.6,16-16.6,16H1401.1z M1424.2,323 c0-6.6-4.1-11.8-11.6-11.8h-6.6v23.5h6.6C1419.9,334.7,1424.2,329.5,1424.2,323z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1457.3,339v-32h21.5v4.2h-16.7v9.3h16.3v4.2h-16.3v10h16.7v4.2H1457.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M407.1,452.2h-12.3v47.3c4.4,0.2,8.6,1.1,12.6,2.7L407.1,452.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M361.1,499.4v-47.3h-11.5c-1,5.6-1.5,11.4-1.5,17.3v31.3c3.3-0.9,6.7-1.4,10.3-1.4H361.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.7,
    y: 452.2,
    className: "st4",
    width: 12.5,
    height: 47.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M499.7,452.2h-12.5V502c3.9-1.5,8.1-2.4,12.5-2.6V452.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M546.3,500.8v-31.3c0-5.9-0.5-11.7-1.5-17.3h-11.4v47.3h2.6C539.6,499.4,543,499.9,546.3,500.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.3,
    y: 452.2,
    className: "st4",
    width: 12.5,
    height: 47.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M546.3,511.9c-3.2-1.2-6.7-1.9-10.3-1.9h-34.6c-16.1,0-29.3,13.1-29.3,29.3c0,2.2,0.3,4.3,0.7,6.4l73.5-19.8 l13.5-3.6C556.5,517.7,551.8,514,546.3,511.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M564.4,532.1l-18,4.9l-69.3,18.6c5.3,7.8,14.2,13,24.3,13H536c3.6,0,7.1-0.7,10.3-1.9 c11.1-4.2,18.9-14.9,18.9-27.4C565.3,536.9,565,534.4,564.4,532.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M447.1,621.9c6.7,0,12.1-5.4,12.1-12.1V503.6c0-6.7-5.4-12.1-12.1-12.1c-6.7,0-12.1,5.4-12.1,12.1v106.2 C435,616.4,440.4,621.9,447.1,621.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M482.4,611.2v-16.4c0-7.8-5.3-14.3-12.5-16.3v31.2c0,1.9-0.2,3.7-0.7,5.5h9.1 C480.6,615.2,482.4,613.4,482.4,611.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M418.9,569.6c1.7-0.7,3.6-1.3,5.5-1.7v-4C422.7,566,420.9,567.9,418.9,569.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M414.7,615.2H425c-0.4-1.8-0.7-3.6-0.7-5.5v-30.8c-7.2,2.5-12.5,9.3-12.5,17.4v16.1 C411.9,614,413.1,615.2,414.7,615.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M469.9,503.6v11.2c1.9-2.5,4.2-4.7,6.6-6.7v-55.9h-12.5v36.2C467.7,492.4,469.9,497.7,469.9,503.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M424.4,514.8v-11.2c0-5.9,2.3-11.4,6-15.4v-36h-12.6l0.3,56.2C420.4,510.3,422.5,512.4,424.4,514.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M447.1,480.8c2.2,0,4.3,0.3,6.3,0.9v-29.5H441v29.5C443,481.1,445,480.8,447.1,480.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M469.9,563.9v3.7c1.5,0.2,3,0.6,4.5,1.1C472.8,567.3,471.3,565.6,469.9,563.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M470.8,373.1v20.7c0,12.8-10.5,23.3-23.3,23.3c-12.8,0-23.3-10.5-23.3-23.3V373 c-34.7,8.2-62.3,34.6-72.2,68.5h190.3C532.5,407.8,505.1,381.5,470.8,373.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M520.4,645.8c-5.2,0.7-55.9,7.3-73.9,7.3c-17.5,0-67.3-6.6-72.6-7.3C361.8,646,351.5,654,348,665v3.1 h198.3V665C542.8,654,532.5,646,520.4,645.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M374.3,701.1h145.8c12.2,0,22.6-8,26.2-19c0-1,0-2,0-2.9v-0.3H348v0.3c0,1,0,2,0,2.9 C351.7,693.1,362.1,701.1,374.3,701.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M374.3,635.2h0.4l0.4,0c0.5,0.1,54.1,7.3,71.5,7.3c17.9,0,72.3-7.2,72.8-7.3l0.3,0h0.4 c10.2,0,19.4,4,26.3,10.5v-67.8c-3.3,0.9-6.8,1.4-10.3,1.4h-34.6c-5.6,0-10.9-1.2-15.7-3.2c4.6,4.9,7.4,11.5,7.4,18.7v16.4 c0,8.1-6.6,14.7-14.7,14.7h-15.1c-4.1,4.1-9.8,6.7-16.1,6.7s-12-2.5-16.1-6.7h-16.4c-7.4,0-13.4-6-13.4-13.4v-16.1 c0-8.3,3.5-15.7,9-21c-5.2,2.5-11.1,4-17.3,4h-34.6c-3.6,0-7-0.5-10.3-1.4v67.8C354.9,639.2,364.1,635.2,374.3,635.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M520.1,711.7H374.3c-8.7,0-16.7-2.9-23.2-7.8c11,42.8,49.8,74.4,96.1,74.4h0c46.2,0,85-31.6,96.1-74.4 C536.8,708.8,528.8,711.7,520.1,711.7z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M447.5,351.1c-7,0-12.6,5.7-12.6,12.6v7.3v15.5v7.4c0,7,5.7,12.6,12.6,12.6c7,0,12.6-5.7,12.6-12.6v-7.3 v-15.5v-7.4C460.2,356.8,454.5,351.1,447.5,351.1z M452.9,387.2v10c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3v-10v-16.8v-10 c0-2.9,2.4-5.3,5.3-5.3c2.9,0,5.3,2.4,5.3,5.3v10V387.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M329.9,532.1c-0.6,2.3-0.9,4.7-0.9,7.2c0,12.5,7.9,23.2,19,27.4c0,0,0,0,0,0c0.3,0.1,0.7,0.2,1,0.4 c0.1,0,0.2,0.1,0.3,0.1c0.3,0.1,0.6,0.2,0.9,0.3c0.1,0,0.3,0.1,0.4,0.1c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.3,0.1,0.5,0.1 c0.3,0.1,0.5,0.1,0.8,0.2c0.2,0,0.4,0.1,0.6,0.1c0.2,0,0.5,0.1,0.7,0.1c0.2,0,0.5,0.1,0.7,0.1c0.2,0,0.4,0.1,0.7,0.1 c0.3,0,0.6,0,0.9,0.1c0.2,0,0.4,0,0.5,0c0.5,0,0.9,0,1.4,0h34.6c10.1,0,19.1-5.2,24.3-13L329.9,532.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M392.9,510.1h-34.6c-0.5,0-1.1,0-1.6,0.1c-0.2,0-0.3,0-0.5,0c-0.4,0-0.8,0.1-1.2,0.1c-0.2,0-0.3,0-0.5,0.1 c-0.5,0.1-1,0.1-1.5,0.2c-0.2,0-0.3,0.1-0.5,0.1c-0.4,0.1-0.7,0.1-1.1,0.2c-0.2,0.1-0.5,0.1-0.7,0.2c-0.3,0.1-0.6,0.2-0.8,0.2 c-0.2,0.1-0.5,0.1-0.7,0.2c-0.4,0.1-0.9,0.3-1.3,0.4c-5.5,2.1-10.2,5.7-13.5,10.4L348,526l73.5,19.8c0.5-2.1,0.7-4.2,0.7-6.4 C422.2,523.2,409,510.1,392.9,510.1z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M718.3,409.7v327.5c0,21.8-17.7,39.5-39.5,39.5s-39.5-17.7-39.5-39.5V409.7c0-21.8,17.7-39.5,39.5-39.5 S718.3,387.9,718.3,409.7z M661.9,330.7c0-9.4,7.6-16.9,16.9-16.9c9.4,0,16.9,7.6,16.9,16.9v28.2h-5.6 C674.5,358.9,661.9,346.3,661.9,330.7z M684.5,409.7c0-3.1-2.5-5.6-5.6-5.6c-3.1,0-5.6,2.5-5.6,5.6v327.5c0,3.1,2.5,5.6,5.6,5.6 c3.1,0,5.6-2.5,5.6-5.6V409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M825.6,409.7v84.7h-33.9v-84.7c0-3.1-2.5-5.6-5.6-5.6c-3.1,0-5.6,2.5-5.6,5.6v327.5c0,3.1,2.5,5.6,5.6,5.6 c3.1,0,5.6-2.5,5.6-5.6v-192c0-3.1-2.5-5.6-5.6-5.6v-33.9c21.8,0,39.5,17.7,39.5,39.5v192c0,21.8-17.7,39.5-39.5,39.5 s-39.5-17.7-39.5-39.5V409.7c0-21.8,17.7-39.5,39.5-39.5S825.6,387.9,825.6,409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M932.9,370.2v367c0,21.8-17.7,39.5-39.5,39.5s-39.5-17.7-39.5-39.5v-367h33.9v367c0,3.1,2.5,5.6,5.6,5.6 c3.1,0,5.6-2.5,5.6-5.6v-367H932.9z M882.1,358.9h-5.6v-28.2c0-9.4,7.6-16.9,16.9-16.9c9.4,0,16.9,7.6,16.9,16.9 C910.3,346.3,897.7,358.9,882.1,358.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1040.2,409.7v367h-33.9v-367c0-3.1-2.5-5.6-5.6-5.6H995v372.7h-33.9V370.2h39.5 C1022.5,370.2,1040.2,387.9,1040.2,409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1209.6,409.7v327.5c0,21.8-17.7,39.5-39.5,39.5s-39.5-17.7-39.5-39.5V409.7c0-21.8,17.7-39.5,39.5-39.5 S1209.6,387.9,1209.6,409.7z M1175.7,409.7c0-3.1-2.5-5.6-5.6-5.6s-5.6,2.5-5.6,5.6v327.5c0,3.1,2.5,5.6,5.6,5.6s5.6-2.5,5.6-5.6 V409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1316.9,409.7v367H1283v-367c0-3.1-2.5-5.6-5.6-5.6h-5.6v372.7h-33.9V370.2h39.5 C1299.2,370.2,1316.9,387.9,1316.9,409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1345.1,776.7V370.2h33.9v406.6H1345.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1486.3,409.7v90.3c0,8.4-2.6,16.2-7.1,22.6c4.5,6.4,7.1,14.2,7.1,22.6v231.5h-33.9V545.2 c0-3.1-2.5-5.6-5.6-5.6h-5.6v237.2h-33.9V370.2h39.5C1468.6,370.2,1486.3,387.9,1486.3,409.7z M1452.4,409.7 c0-3.1-2.5-5.6-5.6-5.6h-5.6v101.6h5.6c3.1,0,5.6-2.5,5.6-5.6V409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1593.5,409.7v84.7h-33.9v-84.7c0-3.1-2.5-5.6-5.6-5.6s-5.6,2.5-5.6,5.6v96h45.2v33.9h-45.2v197.6 c0,3.1,2.5,5.6,5.6,5.6s5.6-2.5,5.6-5.6V550.9h33.9v186.3c0,21.8-17.7,39.5-39.5,39.5s-39.5-17.7-39.5-39.5V409.7 c0-21.8,17.7-39.5,39.5-39.5S1593.5,387.9,1593.5,409.7z M1537.1,330.7c0-9.4,7.6-16.9,16.9-16.9s16.9,7.6,16.9,16.9v28.2h-5.6 C1549.7,358.9,1537.1,346.3,1537.1,330.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M968,323c0-9.8,7.3-16.5,16.6-16.5c6.1,0,10,3,12.5,6.8l-4.1,2.2c-1.7-2.7-4.8-4.6-8.4-4.6 c-6.7,0-11.6,5.1-11.6,12.3c0,7.1,5,12.3,11.6,12.3c3.6,0,6.8-2,8.4-4.6l4.1,2.2c-2.5,3.7-6.4,6.8-12.5,6.8 C975.3,339.5,968,332.8,968,323z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1022.9,323c0-9.5,6.6-16.5,16.1-16.5c9.5,0,16.1,7,16.1,16.5s-6.6,16.5-16.1,16.5 C1029.5,339.5,1022.9,332.5,1022.9,323z M1050.2,323c0-7-4.4-12.3-11.2-12.3c-6.9,0-11.2,5.2-11.2,12.3c0,7,4.3,12.3,11.2,12.3 C1045.8,335.3,1050.2,330,1050.2,323z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1110.8,339v-25l-10.4,25h-2l-10.4-25v25h-4.8v-32h6.9l9.3,22.6l9.3-22.6h6.9v32H1110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1145.1,326.4V307h4.8v19.3c0,5.5,3,9,8.6,9c5.6,0,8.6-3.5,8.6-9V307h4.8v19.4c0,8-4.5,13.1-13.4,13.1 C1149.6,339.5,1145.1,334.3,1145.1,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1224,339l-17.7-24.2V339h-4.8v-32h4.9l17.4,23.6V307h4.8v32H1224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1258.1,339v-32h4.8v32H1258.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1292.4,339v-32h11.4c10,0,16.6,6.8,16.6,16c0,9.2-6.6,16-16.6,16H1292.4z M1315.5,323 c0-6.6-4.1-11.8-11.6-11.8h-6.6v23.5h6.6C1311.2,334.7,1315.5,329.5,1315.5,323z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1369.5,339l-2.6-6.6h-15.3l-2.6,6.6h-5.5l12.7-32h6l12.7,32H1369.5z M1359.2,311.9l-6.2,16.2h12.5 L1359.2,311.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1401.1,339v-32h11.4c10,0,16.6,6.8,16.6,16c0,9.2-6.6,16-16.6,16H1401.1z M1424.2,323 c0-6.6-4.1-11.8-11.6-11.8h-6.6v23.5h6.6C1419.9,334.7,1424.2,329.5,1424.2,323z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1457.3,339v-32h21.5v4.2h-16.7v9.3h16.3v4.2h-16.3v10h16.7v4.2H1457.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M407.1,452.2h-12.3v47.3c4.4,0.2,8.6,1.1,12.6,2.7L407.1,452.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M361.1,499.4v-47.3h-11.5c-1,5.6-1.5,11.4-1.5,17.3v31.3c3.3-0.9,6.7-1.4,10.3-1.4H361.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.7,
    y: 452.2,
    className: "st4",
    width: 12.5,
    height: 47.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M499.7,452.2h-12.5V502c3.9-1.5,8.1-2.4,12.5-2.6V452.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M546.3,500.8v-31.3c0-5.9-0.5-11.7-1.5-17.3h-11.4v47.3h2.6C539.6,499.4,543,499.9,546.3,500.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.3,
    y: 452.2,
    className: "st4",
    width: 12.5,
    height: 47.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M546.3,511.9c-3.2-1.2-6.7-1.9-10.3-1.9h-34.6c-16.1,0-29.3,13.1-29.3,29.3c0,2.2,0.3,4.3,0.7,6.4l73.5-19.8 l13.5-3.6C556.5,517.7,551.8,514,546.3,511.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M564.4,532.1l-18,4.9l-69.3,18.6c5.3,7.8,14.2,13,24.3,13H536c3.6,0,7.1-0.7,10.3-1.9 c11.1-4.2,18.9-14.9,18.9-27.4C565.3,536.9,565,534.4,564.4,532.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M447.1,621.9c6.7,0,12.1-5.4,12.1-12.1V503.6c0-6.7-5.4-12.1-12.1-12.1c-6.7,0-12.1,5.4-12.1,12.1v106.2 C435,616.4,440.4,621.9,447.1,621.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M482.4,611.2v-16.4c0-7.8-5.3-14.3-12.5-16.3v31.2c0,1.9-0.2,3.7-0.7,5.5h9.1 C480.6,615.2,482.4,613.4,482.4,611.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M418.9,569.6c1.7-0.7,3.6-1.3,5.5-1.7v-4C422.7,566,420.9,567.9,418.9,569.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M414.7,615.2H425c-0.4-1.8-0.7-3.6-0.7-5.5v-30.8c-7.2,2.5-12.5,9.3-12.5,17.4v16.1 C411.9,614,413.1,615.2,414.7,615.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M469.9,503.6v11.2c1.9-2.5,4.2-4.7,6.6-6.7v-55.9h-12.5v36.2C467.7,492.4,469.9,497.7,469.9,503.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M424.4,514.8v-11.2c0-5.9,2.3-11.4,6-15.4v-36h-12.6l0.3,56.2C420.4,510.3,422.5,512.4,424.4,514.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M447.1,480.8c2.2,0,4.3,0.3,6.3,0.9v-29.5H441v29.5C443,481.1,445,480.8,447.1,480.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M469.9,563.9v3.7c1.5,0.2,3,0.6,4.5,1.1C472.8,567.3,471.3,565.6,469.9,563.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M470.8,373.1v20.7c0,12.8-10.5,23.3-23.3,23.3c-12.8,0-23.3-10.5-23.3-23.3V373 c-34.7,8.2-62.3,34.6-72.2,68.5h190.3C532.5,407.8,505.1,381.5,470.8,373.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M520.4,645.8c-5.2,0.7-55.9,7.3-73.9,7.3c-17.5,0-67.3-6.6-72.6-7.3C361.8,646,351.5,654,348,665v3.1 h198.3V665C542.8,654,532.5,646,520.4,645.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M374.3,701.1h145.8c12.2,0,22.6-8,26.2-19c0-1,0-2,0-2.9v-0.3H348v0.3c0,1,0,2,0,2.9 C351.7,693.1,362.1,701.1,374.3,701.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M374.3,635.2h0.4l0.4,0c0.5,0.1,54.1,7.3,71.5,7.3c17.9,0,72.3-7.2,72.8-7.3l0.3,0h0.4 c10.2,0,19.4,4,26.3,10.5v-67.8c-3.3,0.9-6.8,1.4-10.3,1.4h-34.6c-5.6,0-10.9-1.2-15.7-3.2c4.6,4.9,7.4,11.5,7.4,18.7v16.4 c0,8.1-6.6,14.7-14.7,14.7h-15.1c-4.1,4.1-9.8,6.7-16.1,6.7s-12-2.5-16.1-6.7h-16.4c-7.4,0-13.4-6-13.4-13.4v-16.1 c0-8.3,3.5-15.7,9-21c-5.2,2.5-11.1,4-17.3,4h-34.6c-3.6,0-7-0.5-10.3-1.4v67.8C354.9,639.2,364.1,635.2,374.3,635.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M520.1,711.7H374.3c-8.7,0-16.7-2.9-23.2-7.8c11,42.8,49.8,74.4,96.1,74.4h0c46.2,0,85-31.6,96.1-74.4 C536.8,708.8,528.8,711.7,520.1,711.7z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M447.5,351.1c-7,0-12.6,5.7-12.6,12.6v7.3v15.5v7.4c0,7,5.7,12.6,12.6,12.6c7,0,12.6-5.7,12.6-12.6v-7.3 v-15.5v-7.4C460.2,356.8,454.5,351.1,447.5,351.1z M452.9,387.2v10c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3v-10v-16.8v-10 c0-2.9,2.4-5.3,5.3-5.3c2.9,0,5.3,2.4,5.3,5.3v10V387.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M329.9,532.1c-0.6,2.3-0.9,4.7-0.9,7.2c0,12.5,7.9,23.2,19,27.4c0,0,0,0,0,0c0.3,0.1,0.7,0.2,1,0.4 c0.1,0,0.2,0.1,0.3,0.1c0.3,0.1,0.6,0.2,0.9,0.3c0.1,0,0.3,0.1,0.4,0.1c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.3,0.1,0.5,0.1 c0.3,0.1,0.5,0.1,0.8,0.2c0.2,0,0.4,0.1,0.6,0.1c0.2,0,0.5,0.1,0.7,0.1c0.2,0,0.5,0.1,0.7,0.1c0.2,0,0.4,0.1,0.7,0.1 c0.3,0,0.6,0,0.9,0.1c0.2,0,0.4,0,0.5,0c0.5,0,0.9,0,1.4,0h34.6c10.1,0,19.1-5.2,24.3-13L329.9,532.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M392.9,510.1h-34.6c-0.5,0-1.1,0-1.6,0.1c-0.2,0-0.3,0-0.5,0c-0.4,0-0.8,0.1-1.2,0.1c-0.2,0-0.3,0-0.5,0.1 c-0.5,0.1-1,0.1-1.5,0.2c-0.2,0-0.3,0.1-0.5,0.1c-0.4,0.1-0.7,0.1-1.1,0.2c-0.2,0.1-0.5,0.1-0.7,0.2c-0.3,0.1-0.6,0.2-0.8,0.2 c-0.2,0.1-0.5,0.1-0.7,0.2c-0.4,0.1-0.9,0.3-1.3,0.4c-5.5,2.1-10.2,5.7-13.5,10.4L348,526l73.5,19.8c0.5-2.1,0.7-4.2,0.7-6.4 C422.2,523.2,409,510.1,392.9,510.1z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Camada_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M436.2,335.1v345.3c0,23-18.7,41.7-41.7,41.7c-23,0-41.7-18.7-41.7-41.7V335.1c0-23,18.7-41.7,41.7-41.7 C417.6,293.4,436.2,312.1,436.2,335.1z M376.7,251.8c0-9.9,8-17.9,17.9-17.9s17.9,8,17.9,17.9v29.8h-6 C390,281.5,376.7,268.2,376.7,251.8z M400.5,335.1c0-3.3-2.7-6-6-6s-6,2.7-6,6v345.3c0,3.3,2.7,6,6,6s6-2.7,6-6V335.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M549.3,335.1v89.3h-35.7v-89.3c0-3.3-2.7-6-6-6s-6,2.7-6,6v345.3c0,3.3,2.7,6,6,6s6-2.7,6-6V478 c0-3.3-2.7-6-6-6v-35.7c23,0,41.7,18.7,41.7,41.7v202.4c0,23-18.7,41.7-41.7,41.7c-23,0-41.7-18.7-41.7-41.7V335.1 c0-23,18.7-41.7,41.7-41.7C530.7,293.4,549.3,312.1,549.3,335.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M662.4,293.4v387c0,23-18.7,41.7-41.7,41.7c-23,0-41.7-18.7-41.7-41.7v-387h35.7v387c0,3.3,2.7,6,6,6 s6-2.7,6-6v-387H662.4z M608.9,281.5h-6v-29.8c0-9.9,8-17.9,17.9-17.9s17.9,8,17.9,17.9C638.6,268.2,625.3,281.5,608.9,281.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M775.5,335.1v387h-35.7v-387c0-3.3-2.7-6-6-6h-6v392.9h-35.7V293.4h41.7 C756.9,293.4,775.5,312.1,775.5,335.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1164.9,335.1v345.3c0,23-18.7,41.7-41.7,41.7c-23,0-41.7-18.7-41.7-41.7V335.1c0-23,18.7-41.7,41.7-41.7 C1146.2,293.4,1164.9,312.1,1164.9,335.1z M1129.2,335.1c0-3.3-2.7-6-6-6c-3.3,0-6,2.7-6,6v345.3c0,3.3,2.7,6,6,6 c3.3,0,6-2.7,6-6V335.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1278,335.1v387h-35.7v-387c0-3.3-2.7-6-6-6h-6v392.9h-35.7V293.4h41.7C1259.3,293.4,1278,312.1,1278,335.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1307.8,722.1V293.4h35.7v428.7H1307.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1456.6,335.1v95.3c0,8.9-2.8,17.1-7.5,23.8c4.7,6.8,7.5,15,7.5,23.8v244.1h-35.7V478c0-3.3-2.7-6-6-6h-6 v250h-35.7V293.4h41.7C1437.9,293.4,1456.6,312.1,1456.6,335.1z M1420.9,335.1c0-3.3-2.7-6-6-6h-6v107.2h6c3.3,0,6-2.7,6-6V335.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1569.7,335.1v89.3H1534v-89.3c0-3.3-2.7-6-6-6c-3.3,0-6,2.7-6,6v101.2h47.6v35.7h-47.6v208.4 c0,3.3,2.7,6,6,6c3.3,0,6-2.7,6-6V484h35.7v196.5c0,23-18.7,41.7-41.7,41.7c-23,0-41.7-18.7-41.7-41.7V335.1 c0-23,18.7-41.7,41.7-41.7C1551,293.4,1569.7,312.1,1569.7,335.1z M1510.2,251.8c0-9.9,8-17.9,17.9-17.9c9.9,0,17.9,8,17.9,17.9 v29.8h-6C1523.5,281.5,1510.2,268.2,1510.2,251.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M353.5,807.2c0-10.4,7.7-17.4,17.5-17.4c6.4,0,10.6,3.2,13.2,7.1l-4.3,2.3c-1.8-2.8-5.1-4.9-8.9-4.9 c-7,0-12.3,5.4-12.3,12.9c0,7.5,5.3,12.9,12.3,12.9c3.8,0,7.1-2.1,8.9-4.9l4.3,2.3c-2.7,3.9-6.8,7.1-13.2,7.1 C361.2,824.6,353.5,817.6,353.5,807.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M486.7,807.2c0-10,6.9-17.4,17-17.4s17,7.4,17,17.4c0,10-6.9,17.4-17,17.4S486.7,817.2,486.7,807.2z  M515.4,807.2c0-7.4-4.6-12.9-11.8-12.9c-7.2,0-11.8,5.5-11.8,12.9c0,7.4,4.5,12.9,11.8,12.9 C510.8,820.1,515.4,814.6,515.4,807.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M654.6,824v-26.4L643.7,824h-2.1l-10.9-26.4V824h-5.1v-33.7h7.2l9.8,23.8l9.8-23.8h7.2V824H654.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M766,810.8v-20.5h5.1v20.4c0,5.8,3.2,9.4,9.1,9.4c5.9,0,9-3.7,9-9.4v-20.4h5.1v20.5 c0,8.4-4.7,13.8-14.1,13.8C770.8,824.6,766,819.1,766,810.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M924.5,824l-18.6-25.5V824h-5.1v-33.7h5.2l18.3,24.9v-24.9h5.1V824H924.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1035.7,824v-33.7h5.1V824H1035.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1147.2,824v-33.7h12c10.5,0,17.5,7.2,17.5,16.9c0,9.8-7,16.8-17.5,16.8H1147.2z M1171.5,807.2 c0-6.9-4.3-12.4-12.3-12.4h-7v24.8h7C1167,819.6,1171.5,814,1171.5,807.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1303.7,824l-2.7-7h-16.1l-2.7,7h-5.8l13.4-33.7h6.3l13.4,33.7H1303.7z M1292.9,795.5l-6.6,17.1h13.2 L1292.9,795.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1412.4,824v-33.7h12c10.5,0,17.5,7.2,17.5,16.9c0,9.8-7,16.8-17.5,16.8H1412.4z M1436.7,807.2 c0-6.9-4.3-12.4-12.3-12.4h-7v24.8h7C1432.2,819.6,1436.7,814,1436.7,807.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1546.9,824v-33.7h22.6v4.4H1552v9.9h17.2v4.4H1552v10.5h17.6v4.4H1546.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M885.6,379.9h-13v49.9c4.7,0.2,9.1,1.2,13.3,2.8L885.6,379.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M837,429.7v-49.8h-12.2c-1,5.9-1.6,12-1.6,18.2v33c3.5-0.9,7.1-1.4,10.8-1.4H837z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 848.3,
    y: 379.9,
    className: "st4",
    width: 13.1,
    height: 49.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M983.2,379.9h-13.1v52.6c4.1-1.6,8.5-2.5,13.1-2.7V379.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1032.4,431.1v-33c0-6.2-0.5-12.3-1.6-18.2h-12v49.8h2.7C1025.3,429.7,1028.9,430.2,1032.4,431.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 994.4,
    y: 379.9,
    className: "st4",
    width: 13.1,
    height: 49.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1032.4,442.9c-3.4-1.3-7.1-2-10.9-2H985c-17,0-30.9,13.9-30.9,30.9c0,2.3,0.3,4.6,0.8,6.8l77.5-20.9 l14.2-3.8C1043.1,448.9,1038.2,445.1,1032.4,442.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1051.4,464.2l-19,5.1l-73,19.6c5.5,8.3,15,13.7,25.6,13.7h36.5c3.8,0,7.5-0.7,10.9-2 c11.7-4.4,20-15.7,20-28.9C1052.4,469.2,1052,466.6,1051.4,464.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M927.8,558.8c7.1,0,12.8-5.7,12.8-12.8V434.1c0-7.1-5.7-12.8-12.8-12.8S915,427,915,434.1V546 C915,553.1,920.8,558.8,927.8,558.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M965,547.5v-17.3c0-8.2-5.6-15.1-13.2-17.1V546c0,2-0.2,3.9-0.7,5.8h9.6C963.1,551.8,965,549.9,965,547.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M898,503.7c1.8-0.8,3.8-1.4,5.8-1.8v-4.2C902.1,499.9,900.1,501.9,898,503.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M893.6,551.8h10.9c-0.5-1.9-0.7-3.8-0.7-5.8v-32.5c-7.6,2.6-13.2,9.8-13.2,18.3v17 C890.6,550.5,891.9,551.8,893.6,551.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M951.8,434.1v11.8c2.1-2.6,4.4-5,7-7.1v-59h-13.1v38.2C949.5,422.3,951.8,427.9,951.8,434.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M903.8,445.9v-11.8c0-6.3,2.4-12,6.4-16.3v-38h-13.3l0.3,59.3C899.6,441.1,901.8,443.4,903.8,445.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M927.8,410c2.3,0,4.6,0.3,6.7,1v-31.1h-13.1v31.1C923.4,410.4,925.6,410,927.8,410z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M951.8,497.7v3.9c1.6,0.3,3.2,0.7,4.7,1.2C954.9,501.2,953.3,499.5,951.8,497.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M952.8,296.6v21.9c0,13.5-11,24.6-24.6,24.6s-24.6-11-24.6-24.6v-22.1c-36.5,8.7-65.7,36.5-76.2,72.3h200.7 C1017.8,333.1,989,305.4,952.8,296.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1005,584.1c-5.5,0.7-58.9,7.7-77.9,7.7c-18.5,0-71-7-76.5-7.7c-12.8,0.2-23.6,8.6-27.4,20.2v3.3h209.1 v-3.3C1028.7,592.7,1017.8,584.2,1005,584.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M851,642.3h153.7c12.9,0,23.9-8.4,27.7-20.1c0-1,0-2.1,0-3.1v-0.4H823.3v0.4c0,1,0,2.1,0,3.1 C827.1,633.9,838.1,642.3,851,642.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M851,572.9h0.4l0.4,0.1c0.6,0.1,57,7.7,75.4,7.7c18.9,0,76.2-7.6,76.8-7.7l0.4,0h0.4 c10.7,0,20.5,4.2,27.7,11.1v-71.5c-3.5,0.9-7.1,1.4-10.9,1.4H985c-5.9,0-11.5-1.2-16.6-3.4c4.8,5.2,7.8,12.1,7.8,19.7v17.3 c0,8.6-7,15.5-15.5,15.5h-16c-4.3,4.3-10.3,7-17,7s-12.6-2.7-17-7h-17.3c-7.8,0-14.2-6.4-14.2-14.2v-17 c0-8.7,3.7-16.6,9.5-22.1c-5.5,2.7-11.7,4.2-18.3,4.2h-36.5c-3.8,0-7.4-0.5-10.8-1.4v71.4C830.5,577.1,840.3,572.9,851,572.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1004.7,653.6H851c-9.2,0-17.6-3.1-24.4-8.3c11.6,45.1,52.5,78.4,101.3,78.4h0 c48.7,0,89.7-33.3,101.3-78.4C1022.3,650.5,1013.9,653.6,1004.7,653.6z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M928.2,273.3c-7.4,0-13.3,6-13.3,13.3v7.7v16.3v7.8c0,7.4,6,13.3,13.3,13.3s13.3-6,13.3-13.3v-7.7v-16.3 v-7.8C941.6,279.3,935.6,273.3,928.2,273.3z M933.8,311.4v10.5c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6v-10.6v-17.7v-10.5 c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6v10.6V311.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M804.2,464.2c-0.6,2.4-0.9,5-0.9,7.6c0,13.2,8.3,24.5,20,28.9c0,0,0,0,0,0c0.4,0.1,0.7,0.3,1.1,0.4 c0.1,0,0.2,0.1,0.3,0.1c0.3,0.1,0.7,0.2,1,0.3c0.1,0,0.3,0.1,0.4,0.1c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.3,0.1,0.5,0.1 c0.3,0.1,0.6,0.1,0.8,0.2c0.2,0,0.4,0.1,0.6,0.1c0.3,0,0.5,0.1,0.8,0.1c0.2,0,0.5,0.1,0.7,0.1c0.2,0,0.5,0.1,0.7,0.1 c0.3,0,0.6,0,0.9,0.1c0.2,0,0.4,0,0.6,0c0.5,0,1,0,1.5,0h36.5c10.7,0,20.1-5.4,25.6-13.7L804.2,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M870.6,440.9h-36.5c-0.6,0-1.2,0-1.7,0.1c-0.2,0-0.4,0-0.5,0c-0.4,0-0.8,0.1-1.2,0.1c-0.2,0-0.4,0-0.5,0.1 c-0.5,0.1-1.1,0.1-1.6,0.2c-0.2,0-0.3,0.1-0.5,0.1c-0.4,0.1-0.7,0.2-1.1,0.2c-0.2,0.1-0.5,0.1-0.7,0.2c-0.3,0.1-0.6,0.2-0.9,0.2 c-0.2,0.1-0.5,0.1-0.7,0.2c-0.5,0.1-0.9,0.3-1.4,0.5c-5.8,2.2-10.7,6-14.3,11l14.3,3.8l77.5,20.8c0.5-2.2,0.8-4.4,0.8-6.8 C901.5,454.8,887.6,440.9,870.6,440.9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal3NoBg);
export default __webpack_public_path__ + "static/media/logo-horizontal-3-no-bg.648d7bc85ff80727258486e11ba66ca3.svg";
export { ForwardRef as ReactComponent };